export default "/images/vendor/quill/icons/align-right.svg?626a3d25131f64ad41bfff6ad1ef10f5";